export default "__VITE_ASSET__D$07vP2R__"